import { render, staticRenderFns } from "./BindsIcon.vue?vue&type=template&id=0c86d4e5&"
import script from "./BindsIcon.vue?vue&type=script&lang=js&"
export * from "./BindsIcon.vue?vue&type=script&lang=js&"
import style0 from "./BindsIcon.vue?vue&type=style&index=0&id=0c86d4e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports